import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const PREFIX_SF = 'sf-';

void i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: {
      // for all available options read the backend's repository readme file
      loadPath: (_languages, namespaces) => {
        const [postfix, namespace] =
          namespaces[0]?.startsWith(PREFIX_SF) === true
            ? ['_sf', namespaces[0].slice(PREFIX_SF.length)]
            : ['', namespaces[0]];

        if (namespace === 'data') {
          return `/json${postfix}/locales/{{lng}}/${namespace}.json`;
        } else if (namespace === 'urls') {
          return `/json${postfix}/${namespace}/{{lng}}/data.json`;
        } else {
          return `/locales/{{lng}}/${namespace ?? ''}.json`;
        }
      },
    },
    debug: false,
    lng: 'ja',
    fallbackLng: 'ja',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });
